import React, { useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { downloadFile, toast } from '@/Helpers/general';
import { AppContext } from '@/Components/Context/AppContext';

const DsarDownloadButton = ({data}) => {
    const { toastRef } = useContext(AppContext);
    const [disabled, setDisabled] = useState(false);

    const downloadDsarRequestArchive = (caseId, type) => {
        downloadFile({
            url: 'dsar-request/download-archive/' + caseId + '/' + type,
            onSuccess: () => {
                toast(toastRef, 'success', 'The requested data is being processed and archived. The' + ' .zip archive will be downloaded automatically soon!');
                setDisabled(false);
            },
            onFailure: () => {
                toast(toastRef, 'error', 'An error occurred during the archiving process, please try again later!');
                setDisabled(false);
            },
        });
    };

    return (
        <Button
            className="p-button-outlined p-button-sm"
            icon="pi pi-download"
            disabled={disabled}
            onClick={() => {
                setDisabled(true);
                downloadDsarRequestArchive(data.case_id, data.type);
            }}
        >
            Download Archive
        </Button>
    );
};

export default DsarDownloadButton;
